import { Transition } from '@uirouter/core';
import { ISCEService, IScope, ITimeoutService, IWindowService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import UtilService from '../../common/services/util.service';
import { OpenPacketDeleteAction } from './packet-delete-dialog.action';
import { PackageThumbnail } from '../../common/services/package/package.model';
import TokenRedirectService from '../../common/services/token-redirect.service';

/* @ngInject */
export default class PacketDeleteDialogController implements ActionHandler {
  private dialogElement;
  private packet: PackageThumbnail;

  protected onDeleteSuccess: (packet: PackageThumbnail) => any;

  constructor(
    private $element,
    private config,
    private $window: IWindowService,
    private actionDispatcher: ActionDispatcherService,
    private tokenRedirectService: TokenRedirectService,
    private $timeout: ITimeoutService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#packet-delete-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenPacketDeleteAction) {
      this.packet = action.packet;
      this.onDeleteSuccess = action.onDeleteSuccess;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onListen() {
    this.close();
    this.$window.open(this.config.paycell.listUrl, '_blank');
  }

  public onDelete() {
    this.close();
    this.onDeleteSuccess(this.packet);
  }
}



// WEBPACK FOOTER //
// ./src/app/packet/packet-delete-dialog/packet-delete-dialog.controller.ts